<template>
  <!-- 商店卡片 -->
  <v-card class="branch-block wd-max-w-full" elevation="0" @click="pathToBranchPage">
    <v-img class="branch-image" cover :src="getImage(branch.cover_image)" height="172" gradient="to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)">
      <v-row align="end" class="branch-row wd-px-3 lightbox fill-height text-white">
        <v-col class="pb-0">
          <div class="branch-image-name mb-1 wd-truncate">{{ branch.name }}</div>
          <div v-if="!hideRating" class="branch-image-text d-flex align-center">
            <funnow-icon class="mr-1" max-width="16" :image-path="'star_white.svg'" />
            <span> {{ branch.rating }} </span>
          </div>
        </v-col>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
import { usePlatformStore } from '@/store-pinia/platform'
import utils from '@/utils'
import { switchBranchAndRedirect } from '@/utils/funbookV2'
import { pushGtmSource } from '@/composition/useGtmSource'
import { useRwgSource } from '@/composition/useRwgSource'
import { GtmSource } from '@/view-models/gtm'

import FunnowIcon from '@/components/icons/funnow-icon'

export default defineComponent({
  name: 'OtherOrNearbyBranchCard',
  components: {
    FunnowIcon,
  },
  props: {
    branch: { type: Object, default: () => ({}) },
    isFunBookV2: { type: Boolean, default: false },
    hideRating: { type: Boolean, default: false },
    gtmSourceOnClick: { type: String, default: null },
  },
  setup(props) {
    const nuxtApp = useNuxtApp()
    const router = useRouter()

    const { isFunBookV2DomainCustomization } = storeToRefs(usePlatformStore())
    const { fromNearbyClick } = useRwgSource()

    function getImage(path) {
      return `${utils.CDN}${utils.imagePath(path)}`
    }

    function pathToBranchPage() {
      // 跳轉前 push source；nearby 情境需另設 flag 給下一頁 branch-detail 用，避免被 rwg 蓋掉 Branch Page Viewed
      if (props.gtmSourceOnClick) {
        pushGtmSource(props.gtmSourceOnClick)
        if (props.gtmSourceOnClick === GtmSource.NEARBY_BRANCH) {
          fromNearbyClick.value = `${props.branch.bid}`
        }
      }

      if (!isFunBookV2DomainCustomization.value) {
        const routerData = props.isFunBookV2
          ? nuxtApp.$routerData.branches_id_funbook(props.branch.bid)
          : nuxtApp.$routerData.branches_id(props.branch.bid)
        router.push(routerData)
        return
      }

      switchBranchAndRedirect(nuxtApp.$axios, props.branch.bid, nuxtApp.$i18n.locale.value)
    }

    return {
      isFunBookV2DomainCustomization,
      getImage,
      pathToBranchPage,
    }
  },
})
</script>

<style scoped lang="scss">
.branch-block {
  width: 380px;
  .branch-image {
    .branch-image-name {
      font-size: 20px;
      font-weight: 500 !important;
    }
    .branch-image-text {
      font-size: $baseFontSize;
    }
  }

  .branch-row {
    box-sizing: border-box;
  }
}
</style>
